export const ru = {
    request_approved: 'Заявка согласована',
    request_not_approved: 'Заявка не согласована',
};
